import { render } from "./CollectionStatus.vue?vue&type=template&id=4e04338b&ts=true"
import script from "./CollectionStatus.vue?vue&type=script&lang=ts"
export * from "./CollectionStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__